<div day></div>
<div class="mobile1-3">
  <div style="display: inline-block; width: 100%; position: relative;">
    <div class="logo">
      <button (click)="openNavModal()" style="font-size: 2em; float: right; margin: 1em;"
        class="BOS rightTxt alignTop">?</button>
    </div>
  </div>
</div>

<div class="mobile4-retina">
  <div class="header">
    <div style="display: inline-block; width: 10%; position: relative;">
      <div class="logo"></div>
    </div>
    <div
      style="display: inline-block; width: 90%; position: relative; overflow-x:auto;vertical-align: top; margin-top: 3px;"
      class="centerContainerNav centerTxt">

      <table class="tg" style="width: 100%; overflow-x:auto;">
        <thead style="width: 100%; overflow-x:auto;">
          <tr>
            <!-- <th class="tg-73oq"><a href="">Sign Profiles</a></th> -->
            <th class="tg-73oq">
              <button class="headerCenterItem p5lr" (click)="gotoZodiacProfiles()" mat-raised-button>
                <span class="BOS">)</span><br>All Zodiac Signs
              </button>
            </th>
            <th class="tg-73oq">
              <button class="headerCenterItem p5lr"
                (click)="setDisplay('showToday'); show2.checked=false; show0.checked=false; show1.checked=false"
                mat-raised-button>
                <span class="BOS">N</span><br>Show Today
              </button>
            </th>
            <th class="tg-73oq">
              <mat-button-toggle-group name="fontStyle" aria-label="Font Style" class="p5lr"
                #group="matButtonToggleGroup">
                <mat-button-toggle value="bold" (click)="setDisplay('show2')" #show2 [checked]="true">Show Start<br>&
                  End Signs</mat-button-toggle>
                <mat-button-toggle value="italic" (click)="setDisplay('none')" #show0 [checked]="show0.checked">Hide
                  All<br>Signs</mat-button-toggle>
                <mat-button-toggle value="italic" (click)="setDisplay('show1')" #show1>Show Sign<br>Details
                </mat-button-toggle>
              </mat-button-toggle-group>
            </th>
            <th class="tg-73oq">
              <app-month-menu class="headerCenterItem p5lr" [monthMenuData]="monthMenuData" (jumpTo)="jumpTo($event)"
                (click)="show2.checked=false; show0.checked=false; show1.checked=false"></app-month-menu>
            </th>
            <th class="tg-73oq">
              <app-sign-menu class="p5lr" [signMenuData]="allSignProfiles" (jumpTo)="jumpTo($event)"
                (click)="show2.checked=false; show0.checked=false; show1.checked=false"></app-sign-menu>
            </th>
          </tr>
        </thead>
      </table>

    </div>
  </div>
</div>

<!-- <style type="text/css">
  .tg  {border-collapse:collapse;border-spacing:0;}
  .tg td{border-color:black;border-style:solid;border-width:1px;font-family:Arial, sans-serif;font-size:14px;
    overflow:hidden;padding:10px 5px;word-break:normal;}
  .tg th{border-color:black;border-style:solid;border-width:1px;font-family:Arial, sans-serif;font-size:14px;
    font-weight:normal;overflow:hidden;padding:10px 5px;word-break:normal;}
  .tg .tg-73oq{border-color:#000000;text-align:left;vertical-align:top}
  </style> -->


<!-- <div style="display: inline;"><div class="logo"> -->
<!-- <img
    src="../../../assets/img/BOS-Logo-dark.png"
    alt="Full Moon"
    width="10%"
  /> -->
<!-- </div></div> -->


<div class="bottomSpacer"></div>

<!-- <button mat-button (click)="openDialog()">Open dialog</button> -->
<!-- <app-dialog-content-example></app-dialog-content-example> -->

<div style="padding: 0px 5px;">
  <ng-template [ngIf]="signDisplayMode === 'cusp'">
    <app-current-day-cusp-display [preDayIcon]="preSignIcon" [postColor]="postSignColor" [preColor]="preSignColor"
      [postDayIcon]="postSignIcon" [preSignName]="preSignName" [postSignName]="postSignName" [preElement]="preElement"
      [preQuality]="preQuality" [preGlyph]="preGlyph" [preHouse]="preHouse" [prePlanet]="prePlanet"
      [postElement]="postElement" [postQuality]="postQuality" [postGlyph]="postGlyph" [postHouse]="postHouse"
      [postPlanet]="postPlanet" [currentMontName]="currentMontName" [currentIndexId]="activeIndexId"
      (seeDifferentMonth)="monthSelector($event)" (setDisplay)="setDisplay($event)"></app-current-day-cusp-display>
  </ng-template>

  <ng-template [ngIf]="signDisplayMode === 'show1'">
    <app-signs1-in-month-display [preDayIcon]="preSignIcon" [postDayIcon]="postSignIcon" [postColor]="postSignColor"
      [preColor]="preSignColor" [preSignName]="preSignName" [postSignName]="postSignName" [preElement]="preElement"
      [preQuality]="preQuality" [preGlyph]="preGlyph" [preHouse]="preHouse" [prePlanet]="prePlanet"
      [prePlanetName]="prePlanetName" [preElementName]="preElementName" [preQualityName]="preQualityName"
      [preHouseName]="preHouseName" [preShortDescription]="preShortDescription" [postElement]="postElement"
      [postQuality]="postQuality" [postGlyph]="postGlyph" [postHouse]="postHouse" [postPlanet]="postPlanet"
      [postPlanetName]="postPlanetName" [postElementName]="postElementName" [postQualityName]="postQualityName"
      [postHouseName]="postHouseName" [postShortDescription]="postShortDescription" [currentMontName]="currentMontName"
      (seeDifferentMonth)="monthSelector($event)" (seeDifferentView)="setDisplay($event)"
      [showStartSign]="showStartSign" (gotoSignProfile)="gotoSignProfile($event)"></app-signs1-in-month-display>
  </ng-template>

  <ng-template [ngIf]="signDisplayMode === 'show2'">
    <app-signs2-in-month-display [preDayIcon]="preSignIcon" [postColor]="postSignColor" [preColor]="preSignColor"
      [postDayIcon]="postSignIcon" [preSignName]="preSignName" [postSignName]="postSignName" [preElement]="preElement"
      [preQuality]="preQuality" [preGlyph]="preGlyph" [preHouse]="preHouse" [prePlanet]="prePlanet"
      [postElement]="postElement" [postQuality]="postQuality" [postGlyph]="postGlyph" [postHouse]="postHouse"
      [postPlanet]="postPlanet" [currentMontName]="currentMontName" [currentIndexId]="activeIndexId"
      (seeDifferentMonth)="monthSelector($event)" (setDisplay)="setDisplay($event)"></app-signs2-in-month-display>
  </ng-template>

  <ng-template [ngIf]="signDisplayMode === 'showToday'">
    <app-current-day-display [currentColor]="currentColor" [currentIcon]="currentIcon"
      [currentSignName]="currentSignName" [currentElement]="currentElement" [currentQuality]="currentQuality"
      [currentGlyph]="currentGlyph" [currentHouse]="currentHouse" [currentPlanet]="currentPlanet"
      [currentShortDescription]="currentShortDescription" [currentIsPreOrPost]="currentIsPreOrPost"
      (seeDifferentMonth)="monthSelector($event)" (currentMonthIndex)="setCurrntMonth($event)"
      (seeDifferentView)="setDisplay($event)">
    </app-current-day-display>
  </ng-template>

  <ng-template [ngIf]="signDisplayMode === 'none'">
    <app-month-date [currentMontName]="currentMontName" (seeDifferentMonth)="monthSelector($event)"></app-month-date>

  </ng-template>

  <app-moon-name-display class="centerContainerNav" [fullMoon]="fullMoon" [fullMoon2]="fullMoon2" [newMoon]="newMoon"
    [newMoon2]="newMoon2" [firstqmoon]="firstqmoon" [firstqmoon2]="firstqmoon2" [lastqmoon]="lastqmoon"
    [lastqmoon2]="lastqmoon2" [fullMoonName]="fullMoonName" [fullMoonName2]="fullMoonName2"></app-moon-name-display>

  <div class="centerCalendarDisplay">
    <div class="absoluteCalendar">
      <ul class="weekendContainer">
        <li class="weekHeader headerColor1">Sunday</li>
        <li class="weekHeader headerColor2">Monday</li>
        <li class="weekHeader headerColor1">Tuesday</li>
        <li class="weekHeader headerColor2">Wednesday</li>
        <li class="weekHeader headerColor1">Thursday</li>
        <li class="weekHeader headerColor2">Friday</li>
        <li class="weekHeader headerColor1">Saturday</li>
      </ul>
      <!-- </div>
</div>

</div>
<div>
  <div class="centerCalendarDisplay"> -->
      <!-- Days of month start-->
      <ul>
        <div *ngIf="preDays">
          <li class="day" *ngFor="let day of preDays">
            <app-day-component [altMonth]="'pre'" [preDayIcon]="preSignIcon" [postDayIcon]="postSignIcon"
              [transferDate]="transferDate" [preSignColor]="preSignColor" [postSignColor]="postSignColor">
            </app-day-component>
          </li>
        </div>

        <div *ngIf="currentDays">
          <li class="day" *ngFor="let day of currentDays">
            <app-day-component [todayIs]="day" [preDayIcon]="preSignIcon" [postDayIcon]="postSignIcon"
              [transferDate]="transferDate" [TodayNumber]="todaysNumberIs" [fullMoon]="fullMoon" [fullMoon2]="fullMoon2"
              [newMoon]="newMoon" [newMoon2]="newMoon2" [firstqmoon]="firstqmoon" [firstqmoon2]="firstqmoon2"
              [lastqmoon]="lastqmoon" [lastqmoon2]="lastqmoon2" [fullMoonName]="fullMoonName"
              [fullMoonName2]="fullMoonName2" [currentMonthIsActive]="currentMonthIsActive"
              [preSignColor]="preSignColor" [postSignColor]="postSignColor" (setModalData)="setModalData($event)">
            </app-day-component>
          </li>
        </div>

        <div *ngIf="postDays">
          <li class="day" *ngFor="let day of postDays">
            <app-day-component [altMonth]="'post'" [preDayIcon]="preSignIcon" [postDayIcon]="postSignIcon"
              [transferDate]="transferDate" [preSignColor]="preSignColor" [postSignColor]="postSignColor">
            </app-day-component>
          </li>
        </div>
      </ul>
    </div>
  </div>
  <div class="bottomSpacer"></div>



  <ng-template [ngIf]="showNavModal === true">
    <div class="mobile1-3">
      <div class="navModal">
        <div class="logo">
          <button (click)="closeNavModal()" style="font-size: 2em; float: right;" class=" rightTxt alignTop">X</button>

        </div>
        <table style="width: 100%;">
          <thead style="width: 100%;">
            <tr class="navModalRows">
              <th>
                <a href="../zodiacsigns/">
                  <button style="font-size:3vh;line-height: 3vh;padding:1vh" class="p5lr maxWidth" mat-raised-button
                    (click)="closeNavModal()">All Zodiac Signs</button>
                </a>
              </th>
            </tr>
            <!-- <tr><h1 style="color: black;" class="centerTxt">Calendar Options</h1><hr></tr> -->
            <tr>
              <!-- <th class="tg-73oq"><a href="">Sign Profiles</a></th> -->
              <th class="tg-73oq">
                <button style="font-size:3vh;line-height: 3vh;padding:1vh" class="p5lr maxWidth"
                  (click)="setDisplay('showToday'); show2.checked=false; show0.checked=false; show1.checked=false; closeNavModal()"
                  mat-raised-button>
                  <span class="BOS">N</span><br>Show Today
                </button>
              </th>
            </tr>
            <tr>
              <th class="tg-73oq">
                <mat-button-toggle-group vertical name="fontStyle" aria-label="Font Style" style="width:100%" class=""
                  #group="matButtonToggleGroup">
                  <mat-button-toggle value="bold" (click)="setDisplay('show2'); closeNavModal()" #show2>Show Start<br>&
                    End Signs</mat-button-toggle>
                  <mat-button-toggle value="italic" (click)="setDisplay('none'); closeNavModal()" #show0>Hide
                    All<br>Signs</mat-button-toggle>
                  <mat-button-toggle value="italic" (click)="setDisplay('show1'); closeNavModal()" #show1>Show
                    Sign<br>Details</mat-button-toggle>
                </mat-button-toggle-group>
              </th>
            </tr>
            <tr>
              <th class="tg-73oq">


                <button style="font-size:3vh;line-height: 3vh;padding:1vh" class="p5lr maxWidth" mat-raised-button
                  (click)="toggleShowMonthsMenu()">Select A Month</button>
                <div [style.display]="showMonthsInMenu === true ? 'contents' :'none'">
                  <button mat-raised-button style="font-size:2.5vh;line-height: 2.5vh;padding:1vh"
                    *ngFor="let month of monthMenuData"
                    (click)="jumpTo({monthId: month.monthId}); closeNavModal()">{{month.monthName}}</button>
                </div>
              </th>

            </tr>
            <tr>
              <th class="tg-73oq">

                <button style="font-size:3vh;line-height: 3vh;padding:1vh" class="p5lr maxWidth" mat-raised-button
                  (click)="toggleShowSignsMenu()">Select Sign</button>
                <!-- <button mat-raised-button *ngFor="let sign of allSignProfiles" style="font-size:2.5vh;line-height: 2.5vh;padding:1vh" > <span class="BOS">{{sign.glyphDisplayCharacter}}</span> {{sign.signName}}</button> -->
                <div [style.display]="showSignsInMenu === true ? 'contents' :'none'">
                  <div *ngFor="let sign of allSignProfiles[0]; let i=index">
                    <button mat-raised-button *ngIf="i<12" style="font-size:2.5vh;line-height: 2.5vh;padding:1vh"
                      (click)="jumpTo({signId: sign.signId}); closeNavModal()"> <span
                        class="BOS">{{sign.glyphDisplayCharacter}}</span> {{sign.signName}}</button>
                  </div>
                </div>

              </th>
            </tr>
          </thead>
        </table>
      </div>
      <div class="nav-modal-background">
      </div>
    </div>
  </ng-template>